import React, { useState, useEffect } from 'react';
import './App.css';
const App = () => {
  const [currentWord, setCurrentWord] = useState('empresa');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentCard, setCurrentCard] = useState(0);
  const [flippedCards, setFlippedCards] = useState<number[]>([]);
  const words = ['empresa', 'saúde mental', 'produtividade', 'carreira', 'gestão'];
  const carouselData = [
    {
      number: 1,
      title: "Respostas que importam",
      text: "Colaboradores compartilham suas experiências por meio de questionários inteligentes, seguros e fáceis de responder."
    },
    {
      number: 2,
      title: "IA que entende e antecipa",
      text: "A inteligência artificial analisa os dados em tempo real, identifica padrões e gera dashboards intuitivos com insights profundos."
    },
    {
      number: 3,
      title: "Insights estratégicos em tempo real",
      text: "Gestores recebem relatórios dinâmicos e alertas automáticos para tomada de decisões ágeis e baseadas em dados."
    },
    {
      number: 4,
      title: "Apoio humano, quando necessário",
      text: "Psicólogos parceiros são acionados de forma ética e integrada, oferecendo suporte personalizado onde e quando for preciso."
    },
    {
      number: 5,
      title: "Soluções que fazem sentido",
      text: "Ações de melhoria são sugeridas com base em dados reais e previsões de impacto no clima e desempenho da equipe."
    },
    {
      number: 6,
      title: "Resultados reais: bem-estar e performance",
      text: "O ambiente se transforma, a produtividade cresce e o bem-estar se consolida como parte da cultura da empresa."
    }
  ];
  const teamData = [
    {
      id: 1,
      name: "Ana Clara Deduck",
      role: "Product Owner",
      quote: "Meu código também cuida: cada linha é uma entrega com empatia.",
      avatar: "/ana.JPG",
      description: "Especialista em UX/UI e desenvolvimento fullstack. Traduz necessidades complexas em soluções tecnológicas simples e eficientes, priorizando sempre a experiência do usuário."
    },
    {
      id: 2,
      name: "Heitor Debortoli",
      role: "Gerente Financeiro",
      quote: "Gosto de criar experiências que conectam pessoas, não só telas.",
      avatar: "/heitor.JPG",
      description: "Responsável pela gestão financeira estratégica da Cope, garantindo sustentabilidade e crescimento do negócio através de análises precisas e tomadas de decisão inteligentes."
    },
    {
      id: 3,
      name: "Laura Pelizzer",
      role: "Tech Lead",
      quote: "Transformar dados em decisões com propósito é o que me move na Cope.",
      avatar: "/laura.JPG",
      description: "Especialista em desenvolvimento fullstack com expertise em algoritmos de IA, estudos de dados e gerenciamento de banco de dados. Lidera a arquitetura técnica da plataforma Cope."
    },
    {
      id: 4,
      name: "Samuel Oliveira",
      role: "Diretor de Comunicação",
      quote: "Cuidar dos dados e da imagem da Cope é o que garante nosso impacto real.",
      avatar: "/samuel.JPG",
      description: "Cuida de todas as mídias da Cope e desenvolve estratégias de marketing que conectam a plataforma com clientes, construindo relacionamentos sólidos e uma marca forte no mercado."
    }
  ];
  const benefits = [
    {
      id: 1,
      color: '#4A90E2',
      frontTitle: 'Redução de afastamentos',
      backTitle: 'Resultado comprovado',
      backText: 'Empresas que usam a Cope registraram uma queda de até 32% nos afastamentos por saúde mental em menos de 6 meses.'
    },
    {
      id: 2,
      color: '#0084FF',
      frontTitle: 'Aumento da produtividade',
      backTitle: 'Impacto mensurável',
      backText: 'Colaboradores em ambientes saudáveis aumentam sua performance em até 26%, segundo nossos dados de acompanhamento contínuo.'
    },
    {
      id: 3,
      color: '#66B2FF',
      frontTitle: 'Cultura mais saudável',
      backTitle: 'Engajamento real',
      backText: '84% dos funcionários relataram maior engajamento e sentimento de pertencimento após o uso da Cope.'
    },
    {
      id: 4,
      color: '#99CCFF',
      frontTitle: 'Conformidade garantida',
      backTitle: 'Conformidade total',
      backText: 'Atendemos às exigências da NR-17, LGPD e diretrizes da Organização Mundial da Saúde para saúde no trabalho.'
    },
    {
      id: 5,
      color: '#002F6C',
      frontTitle: 'Retorno garantido',
      backTitle: 'Investimento inteligente',
      backText: 'Empresas que aplicaram a Cope observaram um ROI de até 4x em apenas 9 meses, com menos turnover e mais produtividade.'
    },
    {
      id: 6,
      color: '#005BBB',
      frontTitle: 'Menos rotatividade',
      backTitle: 'Estabilidade comprovada',
      backText: 'Times com suporte emocional efetivo têm até 41% menos chances de perder talentos, segundo análises da nossa plataforma.'
    }
  ];
  const [isRotating, setIsRotating] = useState(false);

  // Auto-rotate words every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIsRotating(true);
      const currentIndex = words.indexOf(currentWord);
      const nextIndex = (currentIndex + 1) % words.length;
      
      setTimeout(() => {
        setCurrentWord(words[nextIndex]);
        setIsRotating(false);
      }, 300);
    }, 2000); // 2 seconds

    return () => clearInterval(interval);
  }, [currentWord, words]);

  const handleWordClick = () => {
    if (isRotating) return;
    
    setIsRotating(true);
    const currentIndex = words.indexOf(currentWord);
    const nextIndex = (currentIndex + 1) % words.length;
    
    setTimeout(() => {
      setCurrentWord(words[nextIndex]);
      setIsRotating(false);
    }, 300);
  };
  const scrollToNextSection = () => {
    const nextSection = document.querySelector('.section');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    closeMenu();
  };
  const nextCard = () => {
    setCurrentCard((prev) => (prev + 1) % carouselData.length);
  };
  const prevCard = () => {
    setCurrentCard((prev) => (prev - 1 + carouselData.length) % carouselData.length);
  };
  const goToCard = (index: number) => {
    setCurrentCard(index);
  };
  const toggleCardFlip = (cardId: number) => {
    setFlippedCards(prev => 
      prev.includes(cardId) 
        ? prev.filter(id => id !== cardId)
        : [...prev, cardId]
    );
  };
  return (
    <div className="app">
      {/* Brain Logo - Fixed Position */}
      <div className="brain-logo-fixed" onClick={toggleMenu}>
        <img src="/logocerebro (1).png" alt="Cope Brain Logo" />
      </div>
      {/* Menu Lateral */}
      <div className={`menu-overlay ${isMenuOpen ? 'open' : ''}`} onClick={closeMenu}></div>
      <div className={`side-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="side-menu-header">
          <button className="close-menu" onClick={closeMenu}>×</button>
        </div>
        <div className="side-menu-content">
          <div className="menu-item" onClick={() => scrollToSection('como-funciona')}>
            Como funciona?
          </div>
          <div className="menu-item" onClick={() => scrollToSection('beneficios')}>
            Benefícios
          </div>
          <div className="menu-item" onClick={() => scrollToSection('nr1')}>
            NR1 e Regulamentações
          </div>
          <div className="menu-item" onClick={() => scrollToSection('planos')}>
            Planos e Preços
          </div>
          <div className="menu-item" onClick={() => scrollToSection('equipe')}>
            Equipe Cope
          </div>
          <div className="menu-item" onClick={() => scrollToSection('artigos')}>
            Artigos
          </div>
          <div className="menu-item" onClick={() => scrollToSection('contato')}>
            Contato
          </div>
          <div className="menu-item" onClick={() => scrollToSection('depoimentos')}>
            Depoimentos
          </div>
        </div>
      </div>
      {/* Hero Section */}
      <section className="hero">
        {/* Main Content */}
        <div className="hero-content">
          {/* Title with Clickable Word */}
          <h1 className="hero-title">
            COPE - Pelo bem da sua{' '}
            <span className={`word-rotator ${isRotating ? 'rotating' : ''}`} onClick={handleWordClick}>
              {currentWord}
            </span>
          </h1>
          {/* Subtitle */}
          <p className="hero-subtitle">
            Bem-estar e produtividade caminham juntos. A Cope utiliza inteligência artificial para transformar o ambiente de trabalho e prevenir riscos à saúde.
          </p>
          {/* Action Button */}
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={scrollToNextSection}>
              Saiba mais
            </button>
          </div>
        </div>
        {/* Scroll Arrow */}
        <div className="scroll-arrow" onClick={scrollToNextSection}>
          ↓
        </div>
      </section>
      {/* Como Funciona Section */}
      <section id="como-funciona" className="section section-white">
        <div className="container">
          <h2 className="section-title">
            Como funciona?
          </h2>
          <p className="section-subtitle">
            Descubra o processo completo da Cope para transformar o ambiente de trabalho da sua empresa.
          </p>
          <div style={{ 
            overflowX: 'auto', 
            overflowY: 'hidden',
            paddingBottom: '20px',
            scrollbarWidth: 'thin',
            scrollbarColor: 'rgba(0, 47, 108, 0.3) #f8f9fa',
            position: 'relative'
          }}>
            <div style={{ 
              display: 'flex', 
              gap: '20px', 
              padding: '20px 0',
              width: 'max-content'
            }}>
              {carouselData.map((card, index) => (
                <div 
                  key={index} 
                  style={{
                    minWidth: '320px',
                    maxWidth: '320px',
                    padding: '30px',
                    backgroundColor: 'white',
                    borderRadius: '15px',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                    border: 'none',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onClick={() => goToCard(index)}
                >
                  <div style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: '#002F6C',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    marginBottom: '20px'
                  }}>
                    {card.number}
                  </div>
                  <h3 style={{
                    fontSize: '22px',
                    fontWeight: 'bold',
                    color: '#333',
                    margin: '0 0 15px 0',
                    lineHeight: '1.3'
                  }}>
                    {card.title}
                  </h3>
                  <p style={{
                    fontSize: '16px',
                    color: '#666',
                    lineHeight: '1.5',
                    margin: 0
                  }}>
                    {card.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
          
        </div>
      </section>
      {/* Benefits Section */}
      <section id="beneficios" className="section section-blue">
        <div className="container">
          <h2 className="section-title section-title-white">
            BENEFÍCIOS DA COPE
          </h2>
          
          <div className="flip-cards-container">
            {benefits.map((benefit) => (
              <div 
                key={benefit.id}
                className={`flip-card ${flippedCards.includes(benefit.id) ? 'flipped' : ''}`}
                onClick={() => toggleCardFlip(benefit.id)}
              >
                <div className="flip-card-inner">
                  {/* Frente do Card */}
                  <div className="flip-card-front" style={{ backgroundColor: benefit.color, color: 'white' }}>
                    <h3 className="flip-card-title">{benefit.frontTitle}</h3>
                    <div className="flip-card-hint">Clique para descobrir</div>
                  </div>
                  
                  {/* Verso do Card */}
                  <div className="flip-card-back" style={{ backgroundColor: benefit.color, color: 'white' }}>
                    <h3 className="flip-card-title">{benefit.backTitle}</h3>
                    <p className="flip-card-text">{benefit.backText}</p>
                    <div className="flip-card-hint">Clique para voltar</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* NR1 Section */}
      <section id="nr1" className="section section-white">
        <div className="container">
          <h2 className="section-title">
            Conformidade Garantida com a NR-1 e Normas Federais
          </h2>
          <p className="section-subtitle" style={{ textAlign: 'center', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto' }}>
            Ao adquirir a Cope, sua empresa automaticamente está em conformidade com as principais normas regulamentadoras do trabalho brasileiro. Elimine multas, autuações e garante um ambiente legalmente protegido, demonstrando compromisso com a responsabilidade social corporativa.
          </p>
          
          <div className="nr1-content">
            <div className="nr1-cards">
              <div className="nr1-card">
                <div className="nr1-card-icon">NR-1</div>
                <h3>Disposições Gerais</h3>
                <p>Norma que estabelece as diretrizes básicas para a implementação de medidas de proteção à segurança e à saúde dos trabalhadores.</p>
                <div className="compliance-status">
                  <span className="status-badge compliant">✓ Atendida</span>
              </div>
              </div>
              <div className="nr1-card">
                <div className="nr1-card-icon">NR-7</div>
                <h3>PCMSO</h3>
                <p>Programa de Controle Médico de Saúde Ocupacional - estabelece a obrigatoriedade da elaboração e implementação do PCMSO.</p>
                <div className="compliance-status">
                  <span className="status-badge compliant">✓ Atendida</span>
                </div>
              </div>
              <div className="nr1-card">
                <div className="nr1-card-icon">ESG</div>
                <h3>Sustentabilidade</h3>
                <p>Atendimento aos critérios ESG (Environmental, Social, Governance) fortalecendo a reputação corporativa e atraindo investimentos responsáveis.</p>
                <div className="compliance-status">
                  <span className="status-badge compliant">✓ Atendida</span>
                </div>
              </div>
            </div>
            
            <div className="nr1-cta">
              <a 
                href="https://www.gov.br/trabalho-e-emprego/pt-br" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary nr1-button"
              >
                Consultar normas no site oficial do MTE →
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Plans Section */}
      <section id="planos" className="section section-blue">
        <div className="container">
          <h2 className="section-title section-title-white">
            Planos e Preços
          </h2>
          <p className="section-subtitle section-subtitle-white">
            Escolha o plano ideal para sua empresa e transforme o clima organizacional com inteligência, tecnologia e cuidado humano.
          </p>
          <div className="plans-discount">
            <p>Todos os planos são elegíveis para o Selo Cope e oferecem <strong>10% de desconto</strong> no pagamento anual! Preços por funcionário.</p>
          </div>
          
          <div className="plans-grid" style={{ display: 'flex', gap: '30px', justifyContent: 'center', flexWrap: 'nowrap', alignItems: 'flex-start' }}>
            <div className="plan-card" style={{ width: '380px', minWidth: '380px', minHeight: '500px', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
              <div className="plan-header">
                <h3 className="plan-title">Plano Básico</h3>
                <div className="plan-price">
                  <span className="price-main">R$ 9,90</span>
                  <span className="price-period">/colaborador/mês</span>
                </div>
                <div className="plan-annual">
                  <span>Solução essencial para começar</span>
                </div>
              </div>
              <ul className="plan-features" style={{ flex: 1 }}>
                <li>Acesso a página do colaborador e do gestor</li>
                <li>Dashboards para gestores</li>
                <li>Visão geral da empresa</li>
                <li>Conformidade com NR-1</li>
                <li>Selo Cope se elegível</li>
              </ul>
              <button className="plan-btn">Escolher Plano</button>
            </div>

            <div className="plan-card featured" style={{ width: '380px', minWidth: '380px', minHeight: '500px', display: 'flex', flexDirection: 'column' }}>
              <div className="plan-header">
                <h3 className="plan-title">Plano Completo</h3>
                <div className="plan-price">
                  <span className="price-main">R$ 94,90</span>
                  <span className="price-period">/colaborador/mês</span>
                </div>
                <div className="plan-annual">
                  <span>Solução completa com acompanhamento psicológico</span>
                </div>
              </div>
              <ul className="plan-features" style={{ flex: 1 }}>
                <li>Todos os benefícios do Plano Empresarial + Acompanhamento psicológico completo</li>
                <li>Cobrimos a primeira consulta gerando diagnóstico</li>
                <li>Profissional especializado e acompanhamento</li>
                <li>Conformidade com NR-1</li>
                <li>Selo Cope se elegível</li>
              </ul>
              <button className="plan-btn featured">Escolher Plano</button>
            </div>

            <div className="plan-card" style={{ width: '380px', minWidth: '380px', minHeight: '500px', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
              <div className="plan-header">
                <h3 className="plan-title">Plano Empresarial</h3>
                <div className="plan-price">
                  <span className="price-main">R$ 14,90</span>
                  <span className="price-period">/colaborador/mês</span>
                </div>
                <div className="plan-annual">
                  <span>Ideal para empresas com psicólogos próprios</span>
                </div>
              </div>
              <ul className="plan-features" style={{ flex: 1 }}>
                <li>Todos os benefícios do Plano Básico + Acesso a página do psicólogo</li>
                <li>Relatórios individuais para triagem psicológica</li>
                <li>Função de gerar relatório</li>
                <li>Conformidade com NR-1</li>
                <li>Selo Cope se elegível</li>
              </ul>
              <button className="plan-btn">Escolher Plano</button>
            </div>
          </div>
          <div className="plans-security">
            <p>Todos os planos oferecem segurança de dados, conformidade com a LGPD e integração com a NR-1, pautados em ESG.</p>
          </div>
        </div>
      </section>
      {/* Team Section */}
      <section id="equipe" className="section section-white">
        <div className="container">
          <h2 className="section-title">
            Equipe Cope
          </h2>
          <p className="section-subtitle">
            Conheça os especialistas por trás da nossa tecnologia.
          </p>
          
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap', maxWidth: '1400px', margin: '0 auto' }}>
            {teamData.map((member) => (
              <div 
                key={member.id}
                className="team-member-card"
                style={{ 
                  width: '300px', 
                  maxWidth: '100%',
                  height: '380px', 
                  overflow: 'hidden', 
                  borderRadius: '10px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  position: 'relative',
                  cursor: 'pointer',
                  flex: '0 1 auto'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.transition = 'all 0.3s ease';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                  <img 
                    src={member.avatar} 
                    alt={member.name}
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover',
                    objectPosition: 'center top'
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 47, 108, 0.85)',
                    color: 'white',
                    padding: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                    borderRadius: '10px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = '1';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = '0';
                  }}
                >
                  <h3 style={{ margin: '0 0 10px 0', fontSize: '24px', fontWeight: 'bold' }}>{member.name}</h3>
                  <p style={{ margin: '0 0 15px 0', fontSize: '18px', fontWeight: '600' }}>{member.role}</p>
                  <p style={{ margin: '0', fontSize: '14px', lineHeight: '1.4' }}>{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Articles Section */}
      <section id="artigos" className="section section-blue">
        <div className="container">
          <h2 className="section-title section-title-white">
            Artigos
          </h2>
          <p className="section-subtitle section-subtitle-white">
            Conteúdo especializado sobre saúde mental e produtividade.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', maxWidth: '600px', margin: '0 auto' }}>
            <div className="tech-card article-card">
              <h3 className="tech-card-title">NR-1: Saúde Mental no Trabalho</h3>
              <p className="tech-card-text">
                Saiba mais sobre a NR-1 e seus impactos na saúde mental no trabalho. Transforme as exigências legais em vantagem estratégica com a Cope.
              </p>
              <button className="article-btn" onClick={() => window.open('https://www.linkedin.com/feed/update/urn:li:activity:7359293373465214977', '_blank')}>Ver no LinkedIn →</button>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section id="depoimentos" className="section section-white">
        <div className="container">
          <h2 className="section-title">
            Depoimentos
          </h2>
          <p className="section-subtitle">
            Empresas que confiam na Cope e já colhem os resultados.
          </p>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  <img src="/fecap.png" alt="FECAP Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>
                <div className="testimonial-info">
                  <h3 className="testimonial-name">FECAP</h3>
                  <p className="testimonial-role">Educação • 150 funcionários</p>
                </div>
              </div>
              <p className="testimonial-text">
                "A Cope transformou nossa abordagem ao bem-estar dos colaboradores. A plataforma nos permitiu identificar e resolver questões de saúde mental antes que se tornassem problemas maiores. Nossos funcionários se sentem mais apoiados e a instituição mais humana."
              </p>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  <img src="/girakids.png" alt="Gira Kids Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>
                <div className="testimonial-info">
                  <h3 className="testimonial-name">Gira Kids</h3>
                  <p className="testimonial-role">Distribuidora de Brinquedos • 38 funcionários</p>
                </div>
              </div>
              <p className="testimonial-text">
                "A Cope nos ajudou a entender melhor como nossos colaboradores estavam se sentindo. Identificamos pontos fortes e oportunidades de melhoria que antes passavam despercebidos. O processo trouxe mais engajamento, melhor comunicação interna e reforçou o cuidado com a equipe. Aprovado por psicólogos, RH e gestores. Queremos fazer as próximas avaliações para continuar o processo e acreditamos no trabalho da Cope."
              </p>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  <img src="/sec.webp" alt="SEC4U Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>
                <div className="testimonial-info">
                  <h3 className="testimonial-name">SEC4U</h3>
                  <p className="testimonial-role">Empresa de Segurança Digital • 85 funcionários</p>
                </div>
              </div>
              <p className="testimonial-text">
                "A Cope nos proporcionou uma visão completa da saúde mental de nossa equipe, mesmo em um ambiente remoto e altamente tecnológico. Com base nos insights gerados, conseguimos implementar ações preventivas e estratégicas, garantindo maior bem-estar e engajamento dos colaboradores."
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Contact & Newsletter Section */}
      <section id="contato" className="section section-blue">
        <div className="container">
          <h2 className="section-title section-title-white">
            Fale com a Cope
          </h2>
          <p className="section-subtitle section-subtitle-white">
            Entre em contato conosco e receba insights sobre bem-estar corporativo.
          </p>
          
          <div className="contact-newsletter-content">
            <div className="contact-form">
              <h3>Envie uma mensagem</h3>
              <form>
                <div className="form-group">
                  <input type="text" placeholder="Nome completo" required />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="E-mail" required />
                </div>
                <div className="form-group">
                  <input type="text" placeholder="Empresa" required />
                </div>
                <button type="submit" className="contact-btn">
                  Enviar mensagem
                </button>
              </form>
            </div>
            
            <div className="newsletter-section">
              <h3>Receba insights sobre bem-estar corporativo</h3>
              <p>Assine nossa newsletter e fique por dentro de tendências, dicas e novidades da Cope.</p>
              <form className="newsletter-form">
                <div className="newsletter-input-group">
                  <input 
                    type="email" 
                    placeholder="Digite seu melhor e-mail" 
                    required 
                    className="newsletter-input"
                  />
                  <button type="submit" className="newsletter-btn">
                    Assinar agora
                  </button>
                </div>
              </form>
              <div className="contact-info">
                <div className="contact-item">
                  <a href="mailto:plataformacope@gmail.com" className="contact-link">
                    plataformacope@gmail.com
                  </a>
                </div>
                <div className="contact-item">
                  <span>(11) 99999-9999</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="social-links">
            <a href="https://www.instagram.com/cope_ai?igsh=dTN0eXZ5MHB6cGcw" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg className="social-icon instagram-icon" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span>@cope_ai</span>
            </a>
            <a href="https://www.linkedin.com/company/aicope" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg className="social-icon linkedin-icon-white" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              <span>Cope</span>
            </a>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section footer-logo">
              <img src="/logo.png" alt="Cope Logo" />
              <p>
                Transformando ambientes de trabalho através da tecnologia e inovação.
              </p>
            </div>
            <div className="footer-section">
              <h4>Produto</h4>
              <ul>
                <li>Funcionalidades</li>
                <li>Preços</li>
                <li>Integrações</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Empresa</h4>
              <ul>
                <li>Sobre nós</li>
                <li>Carreiras</li>
                <li>Contato</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Suporte</h4>
              <ul>
                <li>Central de ajuda</li>
                <li>Documentação</li>
                <li>Status do sistema</li>
              </ul>
            </div>
          </div>
          <div className="footer-divider">
            <p>&copy; 2024 Cope. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default App;
